var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    !_vm.loaded && _vm.events.length == 0
      ? _c(
          "div",
          { staticClass: "sidebar-loading" },
          [_c("w-progress-circular", { attrs: { small: "" } })],
          1
        )
      : _vm.events.length == 0
      ? _c("div", { staticClass: "sidebar-empty" }, [
          _vm._v(_vm._s(_vm.$ct("sidebar.crm-history.none"))),
        ])
      : _c(
          "div",
          { staticClass: "sidebar-timeline" },
          [
            _vm._l(_vm.events, function (event) {
              return _c(
                "div",
                { key: event.ID, staticClass: "sidebar-event" },
                [
                  _c(
                    "div",
                    { staticClass: "sidebar-event-icon" },
                    [
                      _c("w-fa", {
                        attrs: { icon: event.ComputedProps.icon || "info" },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "sidebar-event-body" }, [
                    _c(
                      "div",
                      { staticClass: "sidebar-event-title" },
                      [
                        event.Pinned
                          ? _c("w-fa", {
                              staticClass: "sidebar-event-pin",
                              attrs: { icon: "thumbtack" },
                            })
                          : _vm._e(),
                        event.ComputedProps.saleId
                          ? _c(
                              "w-link",
                              {
                                attrs: {
                                  to:
                                    "/sales/info/" + event.ComputedProps.saleId,
                                },
                              },
                              [_vm._v(_vm._s(event.ComputedProps.title))]
                            )
                          : [_vm._v(_vm._s(event.ComputedProps.title))],
                      ],
                      2
                    ),
                    _c("div", { staticClass: "sidebar-event-meta" }, [
                      _vm._v(
                        _vm._s(event.Creator) +
                          " · " +
                          _vm._s(event.getTimeStampString())
                      ),
                    ]),
                    event.ComputedProps.message
                      ? _c("div", {
                          directives: [
                            {
                              name: "safe-html",
                              rawName: "v-safe-html",
                              value: event.ComputedProps.message,
                              expression: "event.ComputedProps.message",
                            },
                          ],
                          staticClass: "sidebar-event-message",
                        })
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            _vm.hiddenCount > 0
              ? _c("div", { staticClass: "sidebar-event-more" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$ct("sidebar.crm-history.more", {
                        count: _vm.hiddenCount,
                      })
                    )
                  ),
                ])
              : _vm._e(),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }